import React, { useState } from "react";
import { FaRegLightbulb } from "react-icons/fa";
import "./hint.css";
import { Alert, Collapse } from "reactstrap";

const Hint = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);
  return (
    <div className="hint-box">
      <Alert color="dark" onClick={toggleOpen} className="hint-toggle">
        <FaRegLightbulb size="1.3em" color="yellow" />
      </Alert>

      <Collapse isOpen={isOpen} className="hint-collapse">
        {children}
      </Collapse>
    </div>
  );
};

export default Hint;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-multiple-entries/hint/Hint.js